import React from "react";
import FileUpload from "./FileUpload";
import "./FileUploadModal.css";

const FileUploadModal = ({ isOpen, onClose, onUploadComplete }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content file-upload-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <FileUpload onUploadComplete={onUploadComplete} onClose={onClose} />
      </div>
    </div>
  );
};

export default FileUploadModal;
